import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { getData } from "../../services/base.service";
import PartnerForm from "./PartnerForm";
import { PartnerDetailsType } from "../../types/dataTypes";
import CustomDialog from "../Shared/CustomDialog";

type UpdatePartnerProps = {
    partnerID: number,
    setLoading: Function,
    accessToken: string,
    setFilters: Function,
    isDrawerOpen: boolean,
    setIsDrawerDetailsOpen: Function
    setReload: Function
  }
  
  function UpdatePartner({ setLoading, accessToken, partnerID,  setFilters, isDrawerOpen, setIsDrawerDetailsOpen, setReload }: 
    UpdatePartnerProps) {
    const [partnerData, setPartnerData] = useState<PartnerDetailsType>();

    const fetchPartnertData = async () => {
        getData(`partners/detail/${partnerID}`).then((response) => {
            setPartnerData(response);
        })
        .catch((error) => {
            setLoading(false);
        });
    };

    useEffect(() => {
        setLoading(true);
        fetchPartnertData();
        setLoading(false);
    },[partnerID]);

    return (
        partnerData ? ( // Check if expertData and expertData.expertsDetails are not null before rendering
            <Grid>
              <CustomDialog open={isDrawerOpen} onClose={() => setIsDrawerDetailsOpen(false)} maxWidth="lg" title={partnerData.contact.name}>
                  <PartnerForm type='update' setLoading={setLoading} partnerData={partnerData}
                  setFilters={setFilters} setDetailsDrawerOpen={setIsDrawerDetailsOpen} partnerID={partnerID}
                   setReload={setReload}/>
                </CustomDialog>
            </Grid>
      ) : null // Render nothing if expertData or expertData.expertsDetails is null
    )
  }
  
  export default UpdatePartner;



